import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  updateBuilding,
  addBuilding,
  clearBuilding,
  loadClientsList,
} from '../../../actions/adminAction';
import { setAlert } from '../../../actions/alertAction';
import Alert from '../../../layouts/Alert';

const BuildingForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const building = useSelector((state) => state.admin.building);
  const buildingLoading = useSelector((state) => state.admin.buildingLoading);
  const clientsList = useSelector((state) => state.admin.clientsList);
  const clientListLoading = useSelector(
    (state) => state.admin.clientListLoading,
  );
  const dark = useSelector((state) => state.dark.data);
  const [formData, setFormData] = useState({
    name:
      building === null ? '' : building.name !== undefined ? building.name : '',
    id: building === null ? '' : building.id !== undefined ? building.id : '',
    image:
      building === null
        ? ''
        : building.image !== undefined
        ? building.image
        : '',
    client_id:
      building === null
        ? '1'
        : building.client_id !== undefined
        ? building.client_id
        : '1',
  });

  const [img, setImg] = useState({ data: null, preview: null });

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const { id, name, image, client_id } = formData;

  const onSubmit = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    if (location.pathname.includes('add')) {
      const reader = new FileReader();
      reader.readAsDataURL(img.data);
      reader.onloadend = () => {
        const data = {
          client_id,
          name,
          image: { name: img.data.name, data: reader.result },
        };
        console.log(data);
        dispatch(addBuilding(data));
        setFormData({ name: '', image: '' });
        navigate('/admin/buildings');
      };
    } else if (location.pathname.includes('edit')) {
      console.log('edit');
      if (img.data) {
        const reader = new FileReader();
        reader.readAsDataURL(img.data);
        reader.onloadend = () => {
          const data = {
            client_id,
            name,
            image: { name: img.data.name, data: reader.result },
          };
          console.log(data);
          dispatch(updateBuilding(id, data));
          setFormData({ name: '', image: '' });
          navigate('/admin/buildings');
        };
      } else {
        dispatch(updateBuilding(id, { name, client_id }));
        setFormData({ name: '', image: '' });
        navigate('/admin/buildings');
      }
    }
  };

  useEffect(() => {
    if (clientsList.length === 0 && clientListLoading) {
      dispatch(loadClientsList());
    }
  }, [clientsList, clientListLoading]);

  useEffect(() => {
    if (building == null && location.pathname.includes('edit')) {
      navigate('/admin/buildings');
    }
  }, [building]);

  return (
    <div className='admin-card px-sm-5 py-sm-4 p-2 me-0 mt-0 mb-0 text-main'>
      <div className='mb-2 '>
        <h6 className='text-main my-3'>Admin / Buildings / Building</h6>
        <div className='d-sm-flex  w-100 align-items-center justify-content-between'>
          <div className='d-flex mb-2 mb-sm-0 align-items-center'>
            <div
              className='admin-back mx-2  rounded-circle border border-2 d-flex align-items-center justify-content-center'
              onClick={() => {
                navigate(-1);
              }}
            >
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                fill='currentColor'
                className='bi bi-arrow-left-short'
                viewBox='0 0 16 16'
              >
                <path
                  fillRule='evenodd'
                  d='M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z'
                />
              </svg>
            </div>
            <h4 className='m-0'>
              {location.pathname.includes('add') ? 'Add Building' : 'Edit'}
            </h4>
          </div>
        </div>
      </div>
      <form
        className='card w-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 h-max-content'
        onSubmit={(e) => onSubmit(e)}
      >
        <Alert />
        <div className='row'>
          <div className='col-lg-4 col'>
            <div className='mb-3'>
              <h5 className='text-main fw-bold'>Name</h5>
              <input
                type='text'
                className='form-control rounded admin-list text-main'
                id='name'
                placeholder='Enter name...'
                required
                value={name}
                onChange={(e) => onChange(e)}
              />
            </div>
          </div>
        </div>
        {clientsList.length > 0 && (
          <div className='row'>
            <div className='col-lg-4 col'>
              <div className='mb-3'>
                <h5 className='text-main fw-bold'>Company</h5>
                <select
                  name='client_id'
                  id='client_id'
                  className='form-select admin-list'
                  style={{
                    background: `#272a3d url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='${
                      dark ? 'white' : ''
                    }' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right .75rem center/8px 10px`,
                  }}
                  onChange={(e) => onChange(e)}
                  value={client_id}
                >
                  {clientsList.map((client) => (
                    <option value={client.id}>{client.title}</option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        )}
        <div className='row'>
          <div className='col-lg-4 col'>
            <div className='mb-3'>
              <h5 className='text-main fw-bold'>Image</h5>
              <input
                type='file'
                className='form-control rounded admin-list text-main'
                id='image'
                accept='image/*'
                value={''}
                onChange={(e) => {
                  const img = {
                    preview: URL.createObjectURL(e.target.files[0]),
                    data: e.target.files[0],
                  };
                  setImg(img);
                  console.log(img);
                }}
              />
            </div>
          </div>
        </div>
        <div className='d-flex mb-3'>
          {!location.pathname.includes('add') && (
            <div className=''>
              <h5 className='text-main fw-bold'>Image</h5>
              <div
                className=''
                style={{
                  backgroundImage: `url(${image})`,
                  height: '200px',
                  width: '400px',
                  backgroundSize: 'cover',
                  position: 'relative',
                }}
              ></div>
            </div>
          )}
          {img.preview && (
            <div className=''>
              <h5 className='text-main fw-bold'>Preview</h5>
              <div
                className=''
                style={{
                  backgroundImage: `url(${img.preview})`,
                  height: '200px',
                  width: '400px',
                  backgroundSize: 'cover',
                  position: 'relative',
                }}
              >
                <div className=' position-absolute top-0 w-100 d-flex align-items-center justify-content-end'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    fill='#0098c1'
                    className='bi bi-x-circle-fill m-2 cursor-pointer '
                    viewBox='0 0 16 16'
                    onClick={() => {
                      setImg({
                        data: null,
                        preview: null,
                      });
                    }}
                  >
                    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z' />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className='d-flex align-items-center justify-content-center'>
          <button
            type='submit'
            className='admin-list-btn-secondary text-main btn-block btn px-5'
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
};

export default BuildingForm;
